export default __webpack_public_path__ + "corner.png";